import { FC } from "react";
import { useCreateUserMutation } from "../../../state/api/user.api";
import { User } from "../../../types/User";
import { setLocalStorage } from "../../../util/localData";
import { SignUp } from "./signUp";
import { LocalStorageKeys } from "../../../enum/localStorageKeys.enum";
import { PopupManager } from "../../../util/popupManager";
import { sanitizeUser } from "../user.util";

export const SignUpContainer: FC = () => {
  const [createUser, { isLoading }] = useCreateUserMutation();

  const handleSignUp = async (user: Omit<User, 'id'>) => {
    // resetAllCacheStamps();
    const result: any = await createUser({ user: sanitizeUser(user) });
    if (result.data) {
      setLocalStorage(LocalStorageKeys.hasAccount, true);
      setLocalStorage(LocalStorageKeys.country, user.country);
      setLocalStorage(LocalStorageKeys.accessToken, result.data.accessToken);
      setLocalStorage(LocalStorageKeys.refreshToken, result.data.refreshToken);
      PopupManager.showSuccessToast('User created successfully');
    } else {
      console.log('user not created');
    }
  };

  return <SignUp title="Create Account" loading={isLoading} onSave={handleSignUp} />;
};
